export default {"src":"/_next/static/image/components/ui/Icon/icons/close.f16ef61c726ba640e45cf7620df987f4.svg","height":18,"width":18};